import React from 'react';
import { useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Container, Typography, CircularProgress } from '@mui/material';
import { useGetConfigurations } from '../api/NewsQueueApi';
import NewsQueue from '../newsQueue';

export default function ShorthandPage() {
    const intl = useIntl();
    const { name } = useParams();
    const configurationsQuery = useGetConfigurations({ enabled: true });

    if (configurationsQuery.isLoading) {
        return (
            <Container maxWidth="md" sx={{ py: 4, textAlign: 'center' }}>
                <CircularProgress />
            </Container>
        );
    }

    if (configurationsQuery.isSuccess) {
        const shorthands = configurationsQuery?.data?.result?.desk_shortcuts || {};
        if (!shorthands[name]) {
            return (
                <Container maxWidth="md" sx={{ py: 4 }}>
                    <Typography variant="h6">
                        {intl.formatMessage({ id: 'newsQueue.mediaSelection.shortcuts' })}: {name} {intl.formatMessage({ id: 'monitoring.empty' })}
                    </Typography>
                </Container>
            );
        }
        return <NewsQueue shortcutMedia={shorthands[name]} />;
    }

    return null;
}
